/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFConfidenceData
 */
export interface CRSFConfidenceData {
    /**
     * 
     * @type {number}
     * @memberof CRSFConfidenceData
     */
    score: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFConfidenceData
     */
    version: string;
}

/**
 * Check if a given object implements the CRSFConfidenceData interface.
 */
export function instanceOfCRSFConfidenceData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "score" in value;
    isInstance = isInstance && "version" in value;

    return isInstance;
}

export function CRSFConfidenceDataFromJSON(json: any): CRSFConfidenceData {
    return CRSFConfidenceDataFromJSONTyped(json, false);
}

export function CRSFConfidenceDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFConfidenceData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'score': json['score'],
        'version': json['version'],
    };
}

export function CRSFConfidenceDataToJSON(value?: CRSFConfidenceData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'score': value.score,
        'version': value.version,
    };
}

